(ns common.dom
  (:require [clojure.string :as str]
            [goog.style :as gstyle]))

(defn css-property-value
  "Get computed css property value.

   Example:
   ```css
   :root {
     --some-variable: 500;
   }
   .sample {
     display: 'none';
   }
   ```

   ```clojure
   (css-property-value \"--some-variable\")
   ;; => 500

   (css-property-value (.querySelector js/document \".sample\")
                       \"display\")
   ;; => \"none\"

   (css-property-value \"non-existing-property\")
   ;; => nil
   ```"
  ([property] (css-property-value
               (.-documentElement js/document)
               property))
  ([el property]
   (let [value (gstyle/getComputedStyle el property)]
     (if (js/isNaN (js/parseInt value 10))
       (if (empty? value) nil (str/trim value))
       (js/parseInt value 10)))))

(defn register-transitionend
  "Register transition end event for given HTMLElement"
  [el f]
  (when (= (gstyle/getComputedStyle el "transitionDuration") "0s")
    (set! (.. el -style -transition) "all 1ms ease"))
  (.addEventListener el "transitionend" f))

(defn unregister-transitionend
  "Unregister transition end event for given HTMLElement"
  [el f]
  (.removeEventListener el "transitionend" f))

